import { Inmate } from '@reliance/types/models/Inmate';
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Badge from 'react-bootstrap/Badge';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { formatInmateAVBalance, formatInmateBalance } from '../../format/InmateBalance';
import { formatFullName } from '../../format/FullName';
import RecordRestrictionEditModal from '../RecordRestrictionEditModal';

type HeaderProps = {
  inmate: Inmate & { facilityTitle: string };
  loading: boolean;
  recalculatingBalance: boolean;
  onRefresh(): any;
  onRecalculateBalance(): any;
};

const statusBadgeBg = (enabled: boolean) => (enabled ? 'success' : 'danger');

const Header: React.FC<HeaderProps> = (props) => {
  const [showRecordRestrictionsModal, setShowRecordRestrictionsModal] = useState(false);
  const { inmate } = props;
  const policyIsStandard = inmate.communicationTreatment === 'Standard';

  return (
    <div className="row align-items-start">
      {showRecordRestrictionsModal &&
        <RecordRestrictionEditModal
          inmate={inmate}
          onClose={(success) => {
            if (success) {
              props.onRefresh();
            }
            setShowRecordRestrictionsModal(false);
          }} />
      }

      <div className="col-xs-12 col-sm-7 col-md-7 col-lg-7">
        <h1 className="page-title txt-color-blueDark" style={{ margin: '4px 0 0' }}>
          <OverlayTrigger
            placement="bottom"
            overlay={
              <Tooltip id={`inmate-record-restriction-tooltip`}>
                {inmate.recordRestrictions > 0 ?
                  'Record Restrictions In Place' :
                  'No Restrictions'
                }
              </Tooltip>
            }>
            <button
              type="button"
              style={{ cursor: 'pointer', border: 'none', padding: 0, background: 'transparent' }}
              onClick={() => setShowRecordRestrictionsModal(true)}>
              {inmate.recordRestrictions > 0 ?
                <i className="fas fa-sm fa-user-lock txt-color-red" title="Record Restrictions"></i> :
                <i className="fas fa-sm fa-user" />
              }
            </button>
          </OverlayTrigger>&nbsp;

          {formatFullName(inmate)} (#{inmate.account})&nbsp;
          <button
            type="button"
            style={{ cursor: 'pointer', border: 'none', padding: 0, background: 'transparent' }}
            title="Refresh"
            aria-label="Refresh inmate"
            onClick={() => props.onRefresh()}>
            <i className={`fas fa-sm fa-sync ${props.loading ? 'fa-spin' : ''}`} />
          </button>
        </h1>
        <div style={{ lineHeight: 1.3, marginTop: 2 }}>
          <small>
            <Link to={`/facilities/view/${inmate.facility.id}`}>{inmate.facilityTitle}</Link>
          </small>
        </div>
        <div className="d-flex flex-wrap gap-1" style={{ marginTop: 4, marginBottom: 12 }}>
          <Badge bg={statusBadgeBg(inmate.status === 'Enabled')} style={{ color: 'white' }}>
            Status: {inmate.status}
          </Badge>
          <Badge bg={statusBadgeBg(inmate.phoneStatus === 'Enabled')} style={{ color: 'white' }}>
            Phone: {inmate.phoneStatus}
          </Badge>
          <Badge bg={statusBadgeBg(inmate.textStatus === 'Enabled')} style={{ color: 'white' }}>
            Texting: {inmate.textStatus}
          </Badge>
          <Badge
            bg={policyIsStandard ? 'success' : 'warning'}
            style={{ color: policyIsStandard ? 'white' : 'black' }}>
            Comm. Policy: {inmate.communicationTreatment}
          </Badge>
        </div>
      </div>
      <div className="col-xs-12 col-sm-5 col-md-5 col-lg-5">
        <ul className="sparks" style={{ marginTop: 4 }}>
          <li className="sparks-info">
            <h5 onClick={props.onRecalculateBalance} style={{ cursor: 'pointer' }}>
              Wallet
              {props.recalculatingBalance &&
                <i className="fas fa-sync fa-spin" style={{ marginLeft: 5 }} />
              }
              <span className={inmate.messagingBalance[0].balance <= 0 ? 'txt-color-blue' : 'txt-color-red'}>
                {formatInmateBalance(inmate)}
              </span>
            </h5>
          </li>

          {inmate.audioVideoBalance &&
            <li className="sparks-info">
              <h5>
                AV Wallet
                <span className={inmate.audioVideoBalance[0].balance <= 0 ? 'txt-color-blue' : 'txt-color-red'}>
                  {formatInmateAVBalance(inmate)}
                </span>
              </h5>
            </li>
          }
        </ul>
      </div>
    </div>
  );
};

export default Header;
